// helpers
import useSetEnv from '@global/composable/useSetEnv';

const { setEnv } = useSetEnv();
window.nowEnv = window.nowEnv || {};
window.nowBrand = {};

function globalCtrl() {
  window.nowEnv.NowMyEquipment = setEnv.myEquipment(); // 得知現在的裝置類型
}

export default globalCtrl;
